// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import ga from "@store/Framework/Common/GoogleAnalytics";
import flatten from "lodash/flatten";
import { useSelector } from "react-redux";

const useProductListFiltersParameters = (options?: Toolkit.GoogleAnalytics.Options) => {
    const { attributeTypeFacets, brandFacets, categoryFacets, productLineFacets, productFilters } = useSelector(
        (state: ApplicationState) => {
            const { unfilteredApiParameter, productFilters } = state.pages.productList;
            const unfilteredDataView = getProductsDataView(state, unfilteredApiParameter);
            const unfilteredProductCollection = unfilteredDataView.value ? unfilteredDataView : undefined;
            return {
                attributeTypeFacets: unfilteredProductCollection?.attributeTypeFacets,
                brandFacets: unfilteredProductCollection?.brandFacets,
                categoryFacets: unfilteredProductCollection?.categoryFacets,
                productLineFacets: unfilteredProductCollection?.productLineFacets,
                productFilters,
            };
        },
    );

    const attributes = flatten(
        attributeTypeFacets?.map(attributeType => {
            if (attributeType.attributeValueFacets) {
                return attributeType.attributeValueFacets?.map(attributeValue => {
                    const result: Toolkit.GoogleAnalytics.AnyFilter = {
                        filter_name: `${attributeType.nameDisplay} : ${attributeValue.valueDisplay}`,
                        filter_checked: !!productFilters.attributeValueIds?.find(
                            x => x === attributeValue.attributeValueId,
                        ),
                        filter_type: "attribute",
                    };
                    return result;
                });
            }
            return [];
        }),
    );

    const brands =
        brandFacets?.map(brand => {
            const result: Toolkit.GoogleAnalytics.AnyFilter = {
                filter_name: brand.name,
                filter_checked: !!productFilters.brandIds?.find(x => x === brand.id),
                filter_type: "brand",
            };
            return result;
        }) || [];

    const categories =
        categoryFacets?.map(category => {
            const result: Toolkit.GoogleAnalytics.AnyFilter = {
                filter_name: category.shortDescription,
                filter_checked: !!(productFilters.categoryId === category.categoryId),
                filter_type: "category",
            };
            return result;
        }) || [];

    const productLines =
        productLineFacets?.map(line => {
            const result: Toolkit.GoogleAnalytics.AnyFilter = {
                filter_name: line.name,
                filter_checked: !!productFilters.productLineIds?.find(x => x === line.id),
                filter_type: "product_line",
            };
            return result;
        }) || [];

    const otherFilters: Toolkit.GoogleAnalytics.AnyFilter[] = [
        {
            filter_name: "Previously Purchased Products",
            filter_checked: !!productFilters.previouslyPurchasedProducts,
        },
        {
            filter_name: "Search Within",
            filter_checked: !!productFilters.searchWithinQueries?.length,
            filter_search_terms: productFilters.searchWithinQueries?.join(ga.constants.separator),
        },
        {
            filter_name: "Stocked Items Only",
            filter_checked: !!productFilters.stockedItemsOnly,
        },
    ];

    return [...attributes, ...brands, ...categories, ...productLines, ...otherFilters];
};

export default useProductListFiltersParameters;
